import React, { ReactNode } from 'react';
import { SvgIcon } from '../../../../components/Icon';
import { StyledNavItem } from '../../../../components/SecondaryNav/SecondaryNavUI';
import KubitTooltip from '../../../../components/KubitTooltip';

interface IProps {
  onClick: () => void;
  disabled?: boolean;
  tooltip?: ReactNode;
}

const CreateNewSchemaButton = ({
  onClick,
  disabled = false,
  tooltip,
}: IProps) => (
  <KubitTooltip content={tooltip} noOpenDelay={true} placement="top-start">
    <StyledNavItem
      onClick={onClick}
      $isInteractive={!disabled}
      $isDisabled={disabled}
      id={'create-schema-button'}
    >
      <SvgIcon height={16} width={16} name="plus" customFill="currentColor" />
      New Schema
    </StyledNavItem>
  </KubitTooltip>
);

export default CreateNewSchemaButton;
